import {
  AUTHENTICATING_KLENTY_REQUEST, AUTHENTICATING_KLENTY_SUCCEDDED, AUTHENTICATING_KLENTY_FAILED,
} from '../actionTypes.jsx';
import axios from 'axios';
import {
  activatingIntegrationSuccedded, deactivatingIntegrationSuccedded
} from '../integrations';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const KLENTY_BASE_URL = `${apiUrl}/api/2.0/integrations/klenty`


export function authenticateAccount(apiKey, userName, companyApiKey) {
  return function (dispatch) {
    dispatch(authenticatingAccount());

    const data = {
      apiKey: apiKey,
      userName: userName,
      companyApiKey: companyApiKey
    }

    return axios({
      method: 'POST',
      url: KLENTY_BASE_URL,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      params: data
    })
      .then((response) => {
        dispatch(authenticatingAccountSuccedded(response.data));
        dispatch(activatingIntegrationSuccedded(response.data));
      })
      .catch(error =>
        dispatch(authenticatingAccountFailed(error.errors))
      )
  }
}

function authenticatingAccount() {
  return {
    type: AUTHENTICATING_KLENTY_REQUEST,
    payload: {}
  }
}

function authenticatingAccountSuccedded(json) {
  return {
    type: AUTHENTICATING_KLENTY_SUCCEDDED,
    payload: json
  }
}

function authenticatingAccountFailed(error) {
  return {
    type: AUTHENTICATING_KLENTY_FAILED,
    payload: error
  }
}